import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a73cf8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "juou-card" }
const _hoisted_2 = { class: "store-detail-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "切换门店：", -1))
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "store-detail-body" }
const _hoisted_6 = { class: "store-detail-body-info" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总店负责人：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店名称：", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店电话：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店地址：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  id: "mapPage",
  width: "100%",
  height: "600px",
  frameborder: "0",
  src: "https://apis.map.qq.com/tools/locpicker?search=1&type=1&policy=0&key=THZBZ-X7LRB-C7LUL-J5XY4-XABUT-WGF3N&referer=myapp"
}, null, -1))

import { useBaseUserStore, JuouProForm, JuouProFormItem, useRoute, useBaseAsync, vJuouOperate } from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import defaultImg from '@/assets/store.jpg';
import { ElMessage } from 'element-plus';
import { getCurrentUrl } from '@/utils';
import { cloneDeep } from 'lodash';
import { useStore } from '@/store/store';
import { sha256 } from 'js-sha256';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreDetail',
  setup(__props) {

const route = useRoute();

const editDialog = ref<typeof JuouProForm>();
const mapDialogVisible = ref(false);

const loading = ref(false);

const storeDetails = ref<any[]>([]);
const store = useStore();
const storeDetailOptions = computed(() => storeDetails.value.map((item: any) => ({
  value: item.id,
  label: item.name,
})) || []);
const currentStoreDetail = computed(() => storeDetails.value.find((item) => item.id === store.currentStoreId));
const items: JuouProFormItem[] = [
  {
    name: 'logo',
    label: '门店图片',
    type: 'image',
    action: useApi().uploadImageUrl,
    method: 'post',
    fieldName: 'files',
    headers: {
      Authorization: useBaseUserStore().token,
    },
    baseUrl: useApi().baseUrl,
    multiple: false,
    onSuccess(data) {
      console.log(data.data[0]);
      editDialog.value?.setOneFormState('logo', data.data[0]);
    },
  },
  {
    type: 'numberStr',
    name: 'tel',
    label: '门店电话',
  },
  {
    type: 'link',
    name: 'address',
    label: '门店地址',
    placeholder: '（未选择地址，请点击选择）',
    onClick: () => {
      mapDialogVisible.value = true;
    },
  },
  {
    type: 'string',
    name: 'detailAddress',
    label: '详细地址',
  },
];


const location = ref<any>({
  longtitude: undefined,
  latitude: undefined,
});


const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const [storeDetailRes] = await Promise.all([useApi().storeManagerApi.listManagerStoreStoreManager()]);
    storeDetails.value = storeDetailRes.data.data || [];
    if (storeDetails.value.length && !storeDetails.value.find((item) => item.id === store.currentStoreId)) {
      store.setCurrentStoreId(storeDetails.value[0].id);
    }
  } finally {
    loading.value = false;
  }
});

const authMeituan = useBaseAsync(async(authCode: string) => {
  if (!store.currentStoreId) {
    ElMessage.error('当前未选择门店');
    return;
  }
  try {
    loading.value = true;

    await useApi().meituanPackageApi.authMeituanMeituanPackage({
      authCode,
      storeId: store.currentStoreId,
      redirectUrl: getCurrentUrl(),
    });
    await init();
    ElMessage.success('授权成功');
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});

init();

const showEditDialog = () => {
  if (!currentStoreDetail.value) {
    ElMessage.error('当前未选择门店');
    return;
  }
  editDialog.value?.setFormState(cloneDeep(currentStoreDetail.value));
  editDialog.value?.showDialog();
};

const handleUpdate = useBaseAsync(async(data: any) => {
  if (!currentStoreDetail.value) {
    ElMessage.error('当前未选择门店');
    return;
  }

  const param = {
    ...currentStoreDetail.value,
    ...data,
  };

  if (location.value.longtitude && location.value.latitude) {
    param.geo = {
      ...location.value,
    };
  }

  await useApi().storeApi.updateStoreStore(param);
  ElMessage.success('更新成功');
  init();
});

if (route.query) {
  const { state, auth_code: authCode } = route.query as any;
  if (authCode && state) {
    store.setCurrentStoreId(state);
    authMeituan(authCode);
  }
}


const onChooseLocation = (event: any) => {
  // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
  const loc = event.data;
  // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
  if (loc && loc.module === 'locationPicker') {
    console.log('location', loc);
    editDialog.value?.setOneFormState('address', loc.poiaddress);
    location.value = {
      latitude: String(loc.latlng.lat),
      longtitude: String(loc.latlng.lng),
    };
    mapDialogVisible.value = false;
  }
};


onMounted(() => {
  window.addEventListener('message', onChooseLocation, false);
});

onUnmounted(() => {
  window.removeEventListener('message', onChooseLocation);
});

const handleAuth = () => {
  if (!currentStoreDetail.value) {
    ElMessage.error('当前未选择门店');
    return;
  }
  // todo，独立部署时，需要修改app_key
  window.open(`https://e.dianping.com/dz-open/merchant/auth?app_key=8d3d856393fd00b1&state=${
    currentStoreDetail.value.id}&redirect_url=${getCurrentUrl()}`, '_blank');
};

const handleAuthDouyin = () => {
  if (!currentStoreDetail.value) {
    ElMessage.error('当前未选择门店');
    return;
  }

  // todo，独立部署时，需要修改client_key
  const params = `charset=utf-8&client_key=awmaqf2ww1c6ry6h&out_shop_id=${
    currentStoreDetail.value.id
  }&permission_keys=1,10,12,15,16&solution_key=4&timestamp=${
    Math.floor(new Date().getTime() / 1000)
  }`;

  console.log(params);

  const sign = sha256(`3acb2da0ce6540134c1179d57f493dbe&${params}`);

  window.open(`https://auth.dylk.com/auth-isv/?${params}&sign=${sign}`, '_blank');
};


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_el_select, {
          filterable: "",
          "model-value": _unref(store).currentStoreId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _unref(store).setCurrentStoreId(v))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeDetailOptions.value, (op) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: op.value,
                label: op.label,
                value: op.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          onClick: showEditDialog,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("修改")
          ]),
          _: 1
        })), [
          [_unref(vJuouOperate), 'store_detail_edit']
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_card, {
        shadow: "always",
        style: {"width":"200px","height":"140px"},
        "body-style": "padding:  8px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_image, {
            style: {"height":"122px","width":"184px"},
            fit: "cover",
            src: currentStoreDetail.value?.logo ? `${_unref(useApi)().baseUrl}${currentStoreDetail.value?.logo}` : _unref(defaultImg)
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        (currentStoreDetail.value?.headPrincipal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(currentStoreDetail.value?.headPrincipal), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createTextVNode(_toDisplayString(currentStoreDetail.value?.name), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(currentStoreDetail.value?.tel), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createTextVNode(_toDisplayString(currentStoreDetail.value?.address) + " " + _toDisplayString(currentStoreDetail.value?.detailAddress ? `(${currentStoreDetail.value?.detailAddress})` : ''), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, " 美团：" + _toDisplayString(currentStoreDetail.value?.meituan?.shopname || '未绑定') + " " + _toDisplayString(currentStoreDetail.value?.meituan?.authExpiresAt && `(授权到期：${currentStoreDetail.value?.meituan.authExpiresAt})`), 1),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            link: "",
            type: "primary",
            onClick: handleAuth
          }, {
            default: _withCtx(() => [
              _createTextVNode("授权")
            ]),
            _: 1
          })), [
            [_unref(vJuouOperate), 'store_detail_auth_meituan']
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", null, " 抖音：" + _toDisplayString(currentStoreDetail.value?.douyin?.shopname || '未绑定'), 1),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            link: "",
            type: "primary",
            onClick: handleAuthDouyin
          }, {
            default: _withCtx(() => [
              _createTextVNode("授权")
            ]),
            _: 1
          })), [
            [_unref(vJuouOperate), 'store_detail_auth_meituan']
          ])
        ])
      ])
    ]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "editDialog",
      ref: editDialog,
      title: "修改门店信息",
      "on-ok": _unref(handleUpdate),
      isDialog: true,
      items: items
    }, null, 8, ["on-ok"]),
    _createVNode(_component_el_dialog, {
      title: "选取门店地址",
      modelValue: mapDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mapDialogVisible).value = $event)),
      width: "400"
    }, {
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})